import { useState } from "react";
import * as Assets from "../../utils/svg_assets";
import DetailLikeComment from "./detailLikeComment";

const IconSosmed = (props) => {
  const {
    data,
    isBookmark = false,
    onClick = () => {},
    isShowLike = false,
    onDisplay = () => {},
  } = props;

  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    onDisplay();
  };

  return (
    <>
      <div className="d-flex">
        <div
          className="mr-xs"
          onClick={() => (isShowLike ? handleToggle() : "")}
        >
          <img
            src={data.idLike ? Assets.iconLikeActive : Assets.iconLikeSolid}
            alt="Icon Like Solid"
          />
          &nbsp; {data.totalLike}
        </div>
        <div className="mr-xs">
          <img src={Assets.iconCommentSolid} alt="icon Comment Solid" />
          &nbsp; {data.totalComment}
        </div>
        <div className="mr-xs">
          <img src={Assets.iconView} alt="Icon View" />
          &nbsp; {data.totalViews}
        </div>
        {isBookmark ? (
          <div onClick={onClick}>
            <img
              src={
                data.idFavorite
                  ? Assets.iconBookmarkActive
                  : Assets.iconBookmarkSolid
              }
              alt="Icon Bookmark"
            />
          </div>
        ) : (
          ""
        )}
      </div>
      {isOpen ? (
        <div className="page-detail-like-comment">
          <DetailLikeComment
            title="Like"
            data={data.dataAllLike}
            onClick={handleToggle}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default IconSosmed;
